import axios from "axios";

export const accessControlApi = {
    async check_option_access() {
        try {
            const resp = await axios.get("forwriting/option_access");
            return resp?.data?.message === "ok";
        } catch (error) {
            console.error("check_option_access failed:", error);
            return false;
        }
    },
    async is_over_point_limit() {
        return  await axios.get("forwriting/is_over_point_limit/trial")
    },
    async signin( form) {
        const formData = new FormData()
        formData.append( "username", form.username)
        formData.append( "password", form.password)
        formData.append( "tenant_name", form.tenant_name || "")
        formData.append( "full_name", form.full_name || "")
        return await axios.post("forwriting/signin", formData)
    },
}

export const countPointsApi = {
    async get_plan() {
        return  await axios.get("forwriting/plan")
    },
    async get_monthly_points() {
        return await axios.get("forwriting/monthly_points")
    },
}

export const stripe_API = {
    async get_checkout_url() {
        return await axios.post("forwriting/stripe/create_customer")
    }
}

export const cancellationApi = {
    async get_plan_status() {
        return await axios.get("forwriting/plan_status")
    },
    async cancel_plan() {
        return await axios.post("forwriting/cancel_plan")
    },
}

export const articleListsApi = {
    async getAll() {
        return await axios.get("forwriting/article_lists");
    },

    async get_1( article_list_id) {
        return  await axios.get( `forwriting/article_lists/${article_list_id}`);
    },

    async update( article_list_id, article_list) {
        return  await axios.patch( `forwriting/article_lists/${article_list_id}`, article_list);
    },

    async delete( article_list_id) {
        return await axios.delete(`forwriting/article_lists/${article_list_id}`);
    },

    async create( article_list) {
        return await axios.post( "forwriting/article_lists/new", article_list)
    },

    async get_dashboard_stats(article_list_id) {
        return await axios.get(`forwriting/article_lists/${article_list_id}/dashboard_stats`);
    },
}

// categories
export const categories_Api = {
    async getAll_filter( article_list_id) {
        return await axios.get( `forwriting/article_lists/${article_list_id}/categories`);
    },
    async new( article_list_id, category) {
        return  await axios.post( `forwriting/article_lists/${article_list_id}/categories`, category);
    },
    async get_1( category_id) {
        return  await axios.get( `forwriting/categories/${category_id}`);
    },
    async update( category_id, category) {
        return  await axios.patch( `forwriting/categories/${category_id}`, category);
    },
    async delete(category_id) {
        return  await axios.delete( `forwriting/categories/${category_id}`);
    },
}

// sample_articles
export const sample_articles_Api = {
    async getAll_filter( article_list_id) {
        // console.log( "sample_articles_Api.getAll_filter()",
        //     `forwriting/article_lists/${article_list_id}/sample_articles`)
        return await axios.get( `forwriting/article_lists/${article_list_id}/sample_articles`);
    },
    async new( article_list_id, sample_article) {
        return  await axios.post( `forwriting/article_lists/${article_list_id}/sample_articles`, sample_article);
    },
    async get_1( sample_article_id) {
        return  await axios.get( `forwriting/sample_articles/${sample_article_id}`);
    },
    async update( sample_article_id, sample_article) {
        return  await axios.patch( `forwriting/sample_articles/${sample_article_id}`, sample_article);
    },
    async delete( sample_article_id) {
        return  await axios.delete( `forwriting/sample_articles/${sample_article_id}`);
    },
    async extract_from_url(url) {
        return await axios.post("forwriting/sample_articles/extract_from_url", { url: url })
    },
}

// prompt_templates
export const prompt_templates_Api = {
    async getAll_filter( article_list_id) {
        return await axios.get( `forwriting/article_lists/${article_list_id}/prompt_templates`);
    },
    async new( article_list_id, prompt_template) {
        return  await axios.post( `forwriting/article_lists/${article_list_id}/prompt_templates`, prompt_template);
    },
    async get_1( prompt_template_id) {
        return  await axios.get( `forwriting/prompt_templates/${prompt_template_id}`);
    },
    async update( prompt_template_id, sample_article) {
        return  await axios.patch( `forwriting/prompt_templates/${prompt_template_id}`, sample_article);
    },
    async delete( prompt_template_id) {
        return  await axios.delete( `forwriting/prompt_templates/${prompt_template_id}`);
    },
}

// futured_medias
export const futured_medias_Api = {
    async getAll_filter( article_list_id) {
        return await axios.get( `forwriting/article_lists/${article_list_id}/futured_medias`);
    },
    async new( article_list_id, formData) {
        return  await axios.post(
            `forwriting/article_lists/${article_list_id}/futured_medias`,
            formData);
    },
    async get_1( futured_media_id) {
        console.log( "*** futured_media_id:", futured_media_id)
        return  await axios.get( `forwriting/futured_medias/${futured_media_id}`);
    },
    async update( futured_media_id, formData) {
        return  await axios.patch(
            `forwriting/futured_medias/${futured_media_id}`,
            formData);
    },
    async delete( futured_media_id) {
        return  await axios.delete( `forwriting/futured_medias/${futured_media_id}`);
    },
}

// connections
export const connectionsApi = {
    async getAll_filter( article_list_id) {
        return await axios.get( `forwriting/article_lists/${article_list_id}/connections`);
    },
    async new( article_list_id, connection) {
        return  await axios.post( `forwriting/article_lists/${article_list_id}/connections`, connection);
    },
    async get_1( connection_id) {
        return  await axios.get( `forwriting/connections/${connection_id}`);
    },
    async update( connection_id, connection) {
        return  await axios.patch( `forwriting/connections/${connection_id}`, connection);
    },
    async delete( connection_id) {
        return  await axios.delete( `forwriting/connections/${connection_id}`);
    },
}

// css_selectors
export const css_selectors_Api = {
    async getAll_filter( article_list_id) {
        return await axios.get( `forwriting/article_lists/${article_list_id}/css_selectors`);
    },
    async new( article_list_id, css_selector) {
        return  await axios.post( `forwriting/article_lists/${article_list_id}/css_selectors/new`, css_selector);
    },
    async get_1( css_selector_id) {
        return  await axios.get( `forwriting/css_selectors/${css_selector_id}`);
    },
    async update( article_list_id, css_selector_id, css_selector) {
        return  await axios.patch( `forwriting/article_lists/${article_list_id}/css_selectors/${css_selector_id}`, css_selector);
    },
    async delete( article_list_id, css_selector_id) {
        return  await axios.delete( `forwriting/article_lists/${article_list_id}/css_selectors/${css_selector_id}`);
    },
}

// crawl_sites
export const crawl_sites_Api = {
    async getAll_filter( article_list_id, search_keyword = null) {
        const params = {};
        if (search_keyword && search_keyword.trim()) {
            params.search_keyword = search_keyword.trim();
        }
        return await axios.get( `forwriting/article_lists/${article_list_id}/crawl_sites`, { params });
    },
    async new( article_list_id, crawl_site) {
        return await axios.post( `forwriting/article_lists/${article_list_id}/crawl_sites`, crawl_site);
    },
    async get_1( crawl_site_id) {
        return await axios.get( `forwriting/crawl_sites/${crawl_site_id}`);
    },
    async update( crawl_site_id, crawl_site) {
        return await axios.patch( `forwriting/crawl_sites/${crawl_site_id}`, crawl_site);
    },
    async delete( crawl_site_id) {
        return await axios.delete( `forwriting/crawl_sites/${crawl_site_id}`);
    },
    async crawl( crawl_site_id) {
        return await axios.post( `forwriting/crawl_sites/${crawl_site_id}/crawl`);
    },
}

// crawl_articles
export const crawl_articles_Api = {
    async getAll_filter( article_list_id, sort_by = "created_at", order = "desc", limit = 10, offset = 0, search_keyword = null, crawl_site_id = null, status = "new") {
        const params = { sort_by, order, limit, offset };
        if (search_keyword && search_keyword.trim()) {
            params.search_keyword = search_keyword.trim();
        }
        if (crawl_site_id !== null && crawl_site_id > 0) {
            params.crawl_site_id = crawl_site_id;
        }
        if (status) {
            params.status = status;
        }
        return await axios.get( `forwriting/article_lists/${article_list_id}/crawl_articles`, { params });
    },
    async get_1( crawl_article_id) {
        return await axios.get( `forwriting/crawl_articles/${crawl_article_id}`);
    },
    async update( crawl_article_id, crawl_article) {
        return await axios.patch( `forwriting/crawl_articles/${crawl_article_id}`, crawl_article);
    },
    async delete( crawl_article_id) {
        return await axios.delete( `forwriting/crawl_articles/${crawl_article_id}`);
    },
    async bulk_add( article_list_id, article_ids) {
        return await axios.post( `forwriting/article_lists/${article_list_id}/crawl_articles/bulk_add`, { article_ids });
    },
    async bulk_delete( article_list_id, article_ids) {
        return await axios.post( `forwriting/article_lists/${article_list_id}/crawl_articles/bulk_delete`, { article_ids });
    },
    async refresh( article_list_id) {
        return await axios.post( `forwriting/article_lists/${article_list_id}/crawl_articles/refresh`);
    },
    async add_to_articles( crawl_article_id) {
        return await axios.post( `forwriting/crawl_articles/${crawl_article_id}/add_to_articles`);
    },
    async dismiss( crawl_article_id) {
        return await axios.post( `forwriting/crawl_articles/${crawl_article_id}/dismiss`);
    },
    async bulk_dismiss( article_list_id, article_ids) {
        return await axios.post( `forwriting/article_lists/${article_list_id}/crawl_articles/bulk_dismiss`, { article_ids });
    },
}

// GA integration
export const ga_Api = {
    async test_ga_connection( article_list_id) {
        return await axios.post( `forwriting/article_lists/${article_list_id}/ga_test`);
    },
    async analyze_media( article_list_id, language = "ja") {
        return await axios.post(
            `forwriting/article_lists/${article_list_id}/analyze_media`,
            { language }
        );
    },
    async update_ga_settings( article_list_id, formData) {
        return await axios.patch( `forwriting/article_lists/${article_list_id}/ga_settings`, formData);
    },
}

export const articlesApi = {
    async getAll_filter( article_list_id, sort_by = "created_at", order = "desc", limit = 10, offset = 0, search_keyword = null, article_generate_status = null, cms_post_status = null) {
        const params = {
            sort_by: sort_by,
            order: order,
            limit: limit,
            offset: offset
        };
        // 👉 ADD: Include search_keyword in params if provided
        if (search_keyword && search_keyword.trim()) {
            params.search_keyword = search_keyword.trim();
        }
        // 👉 ADD: Include status filters in params if provided
        if (article_generate_status !== null && article_generate_status >= 0) {
            params.article_generate_status = article_generate_status;
        }
        if (cms_post_status !== null && cms_post_status >= 0) {
            params.cms_post_status = cms_post_status;
        }
        return await axios.get( `forwriting/article_lists/${article_list_id}/articles`, {
            params: params
        });
    },

    async get_generate_types() {
        return await axios.get("forwriting/articles/generate_types");
    },

    async get_ai_models() {
        return await axios.get("forwriting/articles/ai_models");
    },

    async get_article( article_id) {
        return await axios.get( `forwriting/articles/${article_id}`);
    },

    async update( article_id, article) {
        return await axios.patch( `forwriting/articles/${article_id}`, article)
    },

    async delete( article_id) {
        return  await axios.delete( `forwriting/articles/${article_id}`);
    },

    async create( article_list_id, article) {
        return await axios.post(
            `forwriting/article_lists/${article_list_id}/articles/new`, article)
    },

    async generate( article_id, formData) {
        return await axios.post(
            `/forwriting/articles/${article_id}/generate`, formData)
    },

    async upload_audio(article_id, file) {
        const formData = new FormData()
        formData.append("file", file)
        return await axios.post(
            `forwriting/articles/${article_id}/upload_audio`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        )
    },

    async upload_images(article_id, files) {
        const formData = new FormData()
        for (const file of files) {
            formData.append("files", file)
        }
        return await axios.post(
            `forwriting/articles/${article_id}/upload_images`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        )
    },

    async post( article_id, connection_id) {
        // FastAPI Body(embed=True) 需要將 connection_id 包裝在對象中
        return await axios.post(
            `forwriting/articles/${article_id}/post`, 
            { connection_id: connection_id },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
    },

    async create_article_categories( article_id, formData) {
        return await axios.post(
            `/forwriting/articles/${article_id}/article_categories/new`, formData)
    },

    async check_primary_source(urls) {
        return await axios.post("forwriting/articles/check_primary_source", { urls: urls })
    },

}